import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const NewPackFlow = ({setNewPack}) => { 
    let [value, setValue] = useState('');
    const save = useCallback((e) => {
        setNewPack(false);
    }, [value, setNewPack]);
    return (
        <div className="new-pack-flow">
          <div className="name-container">
            <input value={value} onChange={e => setValue(e.target.value)} placeholder="Type name"/>
          </div>
          <div className="drop-content-here">
            Drop samples and presets here
          </div>
          <div onClick={save} className="save-pack-btn">
            Save
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPackFlow);
